// HS-06: mobile product gallery — remove prev/next arrows, enable thumbnail nav under the main image.
// Runs after the theme's own slick init has had a chance to fire, then takes over: unslicks
// the main slider (if already initialized) and re-inits it with arrows off and asNavFor wired
// to the thumbnail strip (.slider-nav), which is hidden on desktop/tablet via CSS.
jQuery(function ($) {
  function initMobileGallery() {
    if ($(window).width() >= 992) return;

    var $main = $('.slider-for');
    var $nav = $('.slider-nav');
    if (!$main.length) return;

    if ($main.hasClass('slick-initialized')) {
      $main.slick('unslick');
    }
    if ($nav.length && $nav.hasClass('slick-initialized')) {
      $nav.slick('unslick');
    }

    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: $nav.length ? '.slider-nav' : undefined
    });

    if ($nav.length) {
      // Reveal (CSS keeps it display:none until this class is added) and initialize slick
      // in the same synchronous call — so the browser never paints the raw, unstyled,
      // full-width stacked list of images before slick restructures it into a row.
      $nav.addClass('hs06-ready');
      $nav.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        focusOnSelect: true,
        arrows: false,
        dots: false,
        infinite: false,
        centerMode: false
      });
    }
  }

  // Theme's own mobile slick init runs on a 300ms/500ms setTimeout — wait past both, then
  // override. Shortened from 700ms since the CSS above now hides the thumbnail row until
  // it's actually styled, so there's no visible flash even if this fires a bit earlier.
  setTimeout(initMobileGallery, 400);
});
